<nav mat-tab-nav-bar  *ngIf="setupObs | async as setup" mat-stretch-tabs="false" mat-align-tabs="start" backgroundColor="theme" class="sub-navBar navbar1" [tabPanel]="tabPanel">
  <a mat-tab-link *ngFor="let link of setup.links" (click)="activeLink = link.name" [active]="checkActive(link.name,link.path)"
    [routerLink]="[link.path]">{{link.name}}  </a>
</nav>

<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>